/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API for the Verdi Dashboard application
 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { customFetch } from "../custom-fetch.ts";
import type {
	CreateIrrigationSet400,
	CreateIrrigationSet500,
	DeleteIrrigationSet400,
	DeleteIrrigationSet404,
	DeleteIrrigationSet500,
	GetIrrigationSet400,
	GetIrrigationSet404,
	GetIrrigationSet500,
	IrrigationSet,
	IrrigationSetCreate,
	IrrigationSetUpdate,
	ListIrrigationSets200,
	ListIrrigationSets400,
	ListIrrigationSets500,
	ListIrrigationSetsParams,
	UpdateIrrigationSet400,
	UpdateIrrigationSet404,
	UpdateIrrigationSet500,
} from "./schemas";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
	query: T,
	queryKey: K,
): T & { queryKey: K } => {
	const result = { queryKey } as T & { queryKey: K };
	for (const key of Object.keys(query)) {
		// The explicit queryKey always wins, matching the previous
		// `{ ...query, queryKey }` spread where it was set last.
		if (key === "queryKey") continue;
		Object.defineProperty(result, key, {
			enumerable: true,
			configurable: true,
			get: () => (query as Record<string, unknown>)[key],
		});
	}
	return result;
};

export const getListIrrigationSetsUrl = (params?: ListIrrigationSetsParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/irrigation-sets?${stringifiedParams}`
		: `/irrigation-sets`;
};

/**
 * @summary List irrigation sets for the authenticated user
 */
export const listIrrigationSets = async (
	params?: ListIrrigationSetsParams,
	options?: Parameters<typeof customFetch>[1],
): Promise<ListIrrigationSets200> => {
	return customFetch<ListIrrigationSets200>(getListIrrigationSetsUrl(params), {
		...options,
		method: "GET",
	});
};

export const getListIrrigationSetsQueryKey = (
	params?: ListIrrigationSetsParams,
) => {
	return ["irrigation-sets", ...(params ? [params] : [])] as const;
};

export const getListIrrigationSetsQueryOptions = <
	TData = Awaited<ReturnType<typeof listIrrigationSets>>,
	TError = ListIrrigationSets400 | ListIrrigationSets500,
>(
	params?: ListIrrigationSetsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationSets>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListIrrigationSetsQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listIrrigationSets>>
	> = ({ signal }) => listIrrigationSets(params, { signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listIrrigationSets>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListIrrigationSetsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listIrrigationSets>>
>;
export type ListIrrigationSetsQueryError =
	| ListIrrigationSets400
	| ListIrrigationSets500;

export function useListIrrigationSets<
	TData = Awaited<ReturnType<typeof listIrrigationSets>>,
	TError = ListIrrigationSets400 | ListIrrigationSets500,
>(
	params: undefined | ListIrrigationSetsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationSets>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listIrrigationSets>>,
					TError,
					Awaited<ReturnType<typeof listIrrigationSets>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListIrrigationSets<
	TData = Awaited<ReturnType<typeof listIrrigationSets>>,
	TError = ListIrrigationSets400 | ListIrrigationSets500,
>(
	params?: ListIrrigationSetsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationSets>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listIrrigationSets>>,
					TError,
					Awaited<ReturnType<typeof listIrrigationSets>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListIrrigationSets<
	TData = Awaited<ReturnType<typeof listIrrigationSets>>,
	TError = ListIrrigationSets400 | ListIrrigationSets500,
>(
	params?: ListIrrigationSetsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationSets>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List irrigation sets for the authenticated user
 */

export function useListIrrigationSets<
	TData = Awaited<ReturnType<typeof listIrrigationSets>>,
	TError = ListIrrigationSets400 | ListIrrigationSets500,
>(
	params?: ListIrrigationSetsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationSets>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListIrrigationSetsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List irrigation sets for the authenticated user
 */
export const useSetListIrrigationSetsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		params: ListIrrigationSetsParams | undefined,
		updater:
			| Awaited<ReturnType<typeof listIrrigationSets>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listIrrigationSets>> | undefined,
			  ) => Awaited<ReturnType<typeof listIrrigationSets>> | undefined),
		$exactMatch: boolean = true,
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof listIrrigationSets>>>(
			{ exact: $exactMatch, queryKey: getListIrrigationSetsQueryKey(params) },
			updater,
		);
	};
};

/**
 * @summary List irrigation sets for the authenticated user
 */
export const useGetListIrrigationSetsQueryData = () => {
	const queryClient = useQueryClient();
	return (params?: ListIrrigationSetsParams) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof listIrrigationSets>>>(
			getListIrrigationSetsQueryKey(params),
		);
};

export const getCreateIrrigationSetUrl = () => {
	return `/irrigation-sets`;
};

/**
 * @summary Create a new irrigation set
 */
export const createIrrigationSet = async (
	irrigationSetCreate: IrrigationSetCreate,
	options?: Parameters<typeof customFetch>[1],
): Promise<IrrigationSet> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			);
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<IrrigationSet>(getCreateIrrigationSetUrl(), {
		...options,
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			...getHeaders(options?.headers),
		},
		body: JSON.stringify(irrigationSetCreate),
	});
};

export const getCreateIrrigationSetMutationKey = () =>
	["createIrrigationSet"] as const;

export const getCreateIrrigationSetMutationOptions = <
	TError = CreateIrrigationSet400 | CreateIrrigationSet500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createIrrigationSet>>,
		TError,
		CreateIrrigationSetMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createIrrigationSet>>,
	TError,
	CreateIrrigationSetMutationVariables,
	TContext
> => {
	const mutationKey = getCreateIrrigationSetMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createIrrigationSet>>,
		CreateIrrigationSetMutationVariables
	> = (props) => {
		const { data } = props ?? {};

		return createIrrigationSet(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateIrrigationSetMutationResult = NonNullable<
	Awaited<ReturnType<typeof createIrrigationSet>>
>;
export type CreateIrrigationSetMutationBody = IrrigationSetCreate;
export type CreateIrrigationSetMutationError =
	| CreateIrrigationSet400
	| CreateIrrigationSet500;
export type CreateIrrigationSetMutationVariables = {
	data: IrrigationSetCreate;
};

/**
 * @summary Create a new irrigation set
 */
export const useCreateIrrigationSet = <
	TError = CreateIrrigationSet400 | CreateIrrigationSet500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createIrrigationSet>>,
			TError,
			CreateIrrigationSetMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof createIrrigationSet>>,
	TError,
	CreateIrrigationSetMutationVariables,
	TContext
> => {
	return useMutation(
		getCreateIrrigationSetMutationOptions(options),
		queryClient,
	);
};
export const getGetIrrigationSetUrl = (irrigationSetId: string) => {
	return `/irrigation-sets/${irrigationSetId}`;
};

/**
 * @summary Get a single irrigation set by ID
 */
export const getIrrigationSet = async (
	irrigationSetId: string,
	options?: Parameters<typeof customFetch>[1],
): Promise<IrrigationSet> => {
	return customFetch<IrrigationSet>(getGetIrrigationSetUrl(irrigationSetId), {
		...options,
		method: "GET",
	});
};

export const getGetIrrigationSetQueryKey = (irrigationSetId: string) => {
	return ["irrigation-sets", irrigationSetId] as const;
};

export const getGetIrrigationSetQueryOptions = <
	TData = Awaited<ReturnType<typeof getIrrigationSet>>,
	TError = GetIrrigationSet400 | GetIrrigationSet404 | GetIrrigationSet500,
>(
	irrigationSetId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationSet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetIrrigationSetQueryKey(irrigationSetId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getIrrigationSet>>
	> = ({ signal }) =>
		getIrrigationSet(irrigationSetId, { signal, ...requestOptions });

	return {
		queryKey,
		queryFn,
		enabled: irrigationSetId !== null && irrigationSetId !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getIrrigationSet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIrrigationSetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getIrrigationSet>>
>;
export type GetIrrigationSetQueryError =
	| GetIrrigationSet400
	| GetIrrigationSet404
	| GetIrrigationSet500;

export function useGetIrrigationSet<
	TData = Awaited<ReturnType<typeof getIrrigationSet>>,
	TError = GetIrrigationSet400 | GetIrrigationSet404 | GetIrrigationSet500,
>(
	irrigationSetId: string,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationSet>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getIrrigationSet>>,
					TError,
					Awaited<ReturnType<typeof getIrrigationSet>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIrrigationSet<
	TData = Awaited<ReturnType<typeof getIrrigationSet>>,
	TError = GetIrrigationSet400 | GetIrrigationSet404 | GetIrrigationSet500,
>(
	irrigationSetId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationSet>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getIrrigationSet>>,
					TError,
					Awaited<ReturnType<typeof getIrrigationSet>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIrrigationSet<
	TData = Awaited<ReturnType<typeof getIrrigationSet>>,
	TError = GetIrrigationSet400 | GetIrrigationSet404 | GetIrrigationSet500,
>(
	irrigationSetId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationSet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single irrigation set by ID
 */

export function useGetIrrigationSet<
	TData = Awaited<ReturnType<typeof getIrrigationSet>>,
	TError = GetIrrigationSet400 | GetIrrigationSet404 | GetIrrigationSet500,
>(
	irrigationSetId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationSet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetIrrigationSetQueryOptions(
		irrigationSetId,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a single irrigation set by ID
 */
export const useSetGetIrrigationSetQueryData = () => {
	const queryClient = useQueryClient();
	return (
		irrigationSetId: string,
		updater:
			| Awaited<ReturnType<typeof getIrrigationSet>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof getIrrigationSet>> | undefined,
			  ) => Awaited<ReturnType<typeof getIrrigationSet>> | undefined),
		$exactMatch: boolean = true,
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof getIrrigationSet>>>(
			{
				exact: $exactMatch,
				queryKey: getGetIrrigationSetQueryKey(irrigationSetId),
			},
			updater,
		);
	};
};

/**
 * @summary Get a single irrigation set by ID
 */
export const useGetGetIrrigationSetQueryData = () => {
	const queryClient = useQueryClient();
	return (irrigationSetId: string) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof getIrrigationSet>>>(
			getGetIrrigationSetQueryKey(irrigationSetId),
		);
};

export const getUpdateIrrigationSetUrl = (irrigationSetId: string) => {
	return `/irrigation-sets/${irrigationSetId}`;
};

/**
 * @summary Update an existing irrigation set
 */
export const updateIrrigationSet = async (
	irrigationSetId: string,
	irrigationSetUpdate: IrrigationSetUpdate,
	options?: Parameters<typeof customFetch>[1],
): Promise<IrrigationSet> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			);
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<IrrigationSet>(
		getUpdateIrrigationSetUrl(irrigationSetId),
		{
			...options,
			method: "PATCH",
			headers: {
				"Content-Type": "application/json",
				...getHeaders(options?.headers),
			},
			body: JSON.stringify(irrigationSetUpdate),
		},
	);
};

export const getUpdateIrrigationSetMutationKey = () =>
	["updateIrrigationSet"] as const;

export const getUpdateIrrigationSetMutationOptions = <
	TError =
		| UpdateIrrigationSet400
		| UpdateIrrigationSet404
		| UpdateIrrigationSet500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateIrrigationSet>>,
		TError,
		UpdateIrrigationSetMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateIrrigationSet>>,
	TError,
	UpdateIrrigationSetMutationVariables,
	TContext
> => {
	const mutationKey = getUpdateIrrigationSetMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateIrrigationSet>>,
		UpdateIrrigationSetMutationVariables
	> = (props) => {
		const { irrigationSetId, data } = props ?? {};

		return updateIrrigationSet(irrigationSetId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateIrrigationSetMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateIrrigationSet>>
>;
export type UpdateIrrigationSetMutationBody = IrrigationSetUpdate;
export type UpdateIrrigationSetMutationError =
	| UpdateIrrigationSet400
	| UpdateIrrigationSet404
	| UpdateIrrigationSet500;
export type UpdateIrrigationSetMutationVariables = {
	irrigationSetId: string;
	data: IrrigationSetUpdate;
};

/**
 * @summary Update an existing irrigation set
 */
export const useUpdateIrrigationSet = <
	TError =
		| UpdateIrrigationSet400
		| UpdateIrrigationSet404
		| UpdateIrrigationSet500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateIrrigationSet>>,
			TError,
			UpdateIrrigationSetMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof updateIrrigationSet>>,
	TError,
	UpdateIrrigationSetMutationVariables,
	TContext
> => {
	return useMutation(
		getUpdateIrrigationSetMutationOptions(options),
		queryClient,
	);
};
export const getDeleteIrrigationSetUrl = (irrigationSetId: string) => {
	return `/irrigation-sets/${irrigationSetId}`;
};

/**
 * @summary Soft-delete an irrigation set and detach it from its irrigation events
 */
export const deleteIrrigationSet = async (
	irrigationSetId: string,
	options?: Parameters<typeof customFetch>[1],
): Promise<IrrigationSet> => {
	return customFetch<IrrigationSet>(
		getDeleteIrrigationSetUrl(irrigationSetId),
		{
			...options,
			method: "DELETE",
		},
	);
};

export const getDeleteIrrigationSetMutationKey = () =>
	["deleteIrrigationSet"] as const;

export const getDeleteIrrigationSetMutationOptions = <
	TError =
		| DeleteIrrigationSet400
		| DeleteIrrigationSet404
		| DeleteIrrigationSet500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteIrrigationSet>>,
		TError,
		DeleteIrrigationSetMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deleteIrrigationSet>>,
	TError,
	DeleteIrrigationSetMutationVariables,
	TContext
> => {
	const mutationKey = getDeleteIrrigationSetMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteIrrigationSet>>,
		DeleteIrrigationSetMutationVariables
	> = (props) => {
		const { irrigationSetId } = props ?? {};

		return deleteIrrigationSet(irrigationSetId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteIrrigationSetMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteIrrigationSet>>
>;

export type DeleteIrrigationSetMutationError =
	| DeleteIrrigationSet400
	| DeleteIrrigationSet404
	| DeleteIrrigationSet500;
export type DeleteIrrigationSetMutationVariables = { irrigationSetId: string };

/**
 * @summary Soft-delete an irrigation set and detach it from its irrigation events
 */
export const useDeleteIrrigationSet = <
	TError =
		| DeleteIrrigationSet400
		| DeleteIrrigationSet404
		| DeleteIrrigationSet500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deleteIrrigationSet>>,
			TError,
			DeleteIrrigationSetMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof deleteIrrigationSet>>,
	TError,
	DeleteIrrigationSetMutationVariables,
	TContext
> => {
	return useMutation(
		getDeleteIrrigationSetMutationOptions(options),
		queryClient,
	);
};
